/* eslint no-param-reassign: "error" */

import $ from 'jquery';

import ToggleProductDescription from './ToggleProductDescription';

const grabAndGoParent = document.querySelectorAll( '.wcpa_grab_and_go_checkbox' );
const grabAndGoLabels = document.querySelectorAll( '.wcpa_grab_and_go_checkbox label, .wcpa_addon_dummy_title' );
const legals = document.querySelectorAll( '.wcpa_legals' );
const furkidLegals = document.querySelectorAll( '.furkid_legals label' );
const concession = document.querySelector( 'label[for=concession]' );
const companion = document.querySelector( 'label[for=companion-card-holder]' );

function wrapfurkidLegals() {
	if ( !furkidLegals ) {
		return;
	}
  [...furkidLegals].forEach( ( label ) => {
		label.innerHTML = label.innerHTML.replace( 'Terms', '<a class="wcpa_addon_link" href="#product-descriptionToggle">Terms &amp; Conditions</a>' );
  } );
}

function wrapGrabAndGoText() {
	if ( !grabAndGoLabels ) {
		return;
	}
	[...grabAndGoLabels].forEach( ( label ) => {
		label.innerHTML = label.innerHTML.replace( '+ Add', '<span class="wcpa_grab_and_go_checkbox_highlight">+ Add</span>&#8239; <a class="wcpa_addon_link" href="#product-descriptionToggle">More Info</a>' );
    label.innerHTML = label.innerHTML.replace( '+ More Info', '<a class="wcpa_addon_link" href="#product-descriptionToggle">More Info</a>' );
	} );
}

function hideGrabAndQtyLabel() {
	if ( !grabAndGoParent ) {
		return;
	}
	[...grabAndGoParent].forEach( ( el ) => {
		el.closest( '.wcpa_row' ).nextSibling.querySelector( 'label' ).setAttribute( 'style', 'display:none' );
	} );
}

function wrapLegals() {
	if ( !legals ) {
		return;
	}
	[...legals].forEach( ( label ) => {
		label.innerHTML = label.innerHTML.replace( 'Conditions of Entry', '&#8239;<a href="/conditions-of-entry" target="_blank">Conditions of Entry</a>' );
		label.innerHTML = label.innerHTML.replace( 'Health Declaration', '&#8239;<a href="/health-declaration" target="_blank">Health Declaration</a>' );
    label.innerHTML = label.innerHTML.replace( 'Vaccination Declaration', '&#8239;<a href="/vaccination-declaration" target="_blank">Vaccination Declaration</a>' );
	} );
}

function moreInfo() {
	const moreInfoLink = document.querySelectorAll( '.wcpa_addon_link' );
	[...moreInfoLink].forEach( ( link, index ) => {
		link.addEventListener( 'click', ( e ) => {
			e.preventDefault();
      $( '.product-description' ).show();
      const toggle = document.querySelector( '.product-descriptionToggle' );
      toggle.classList.add( 'is-open' );
      toggle.querySelector( 'span' ).innerHTML = 'More Info';

      document.getElementById( `link-${index + 1}` ).scrollIntoView( {
        behavior: 'smooth',
      } );
		} );
	} );
}

// This function orignally created a toggle. It was requested to show the content at all times so toggling has been disabled for now.
function concessionInfoButton() {
	if ( !concession ) return;
	const icon = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9Z" fill="#AD111E"/> <path d="M8.13771 7.08202H9.85371V13H8.13771V7.08202ZM8.99571 6.25702C8.68038 6.25702 8.42371 6.16535 8.22571 5.98202C8.02771 5.79868 7.92871 5.57135 7.92871 5.30002C7.92871 5.02868 8.02771 4.80135 8.22571 4.61802C8.42371 4.43468 8.68038 4.34302 8.99571 4.34302C9.31104 4.34302 9.56771 4.43102 9.76571 4.60702C9.96371 4.78302 10.0627 5.00302 10.0627 5.26702C10.0627 5.55302 9.96371 5.79135 9.76571 5.98202C9.56771 6.16535 9.31104 6.25702 8.99571 6.25702Z" fill="white"/> </svg>';
	const concessionContent = '<p>One of the following must be presented upon entry or full price will be applicable: Australian Pensioner Concession Card, Healthcare Card, Disability Concession Card, or DVA Gold Card. Student and Senior cards not applicable.</p>';
  const companionContent = '<p>A Carer accompanying a person with a disability who is the holder of a Child Disability Allowance Health Care Card, Disability Pension Card. Carer/Companion Card must be presented on entry.</p>';

	// concession.insertAdjacentHTML( 'afterend', `<button type="button" class="wcpa_info_toggle">${icon}</button>` );
	concession.parentElement.insertAdjacentHTML( 'beforeend', `<div class="wcpa_info_toggle_content">${concessionContent}</div>` );

	// companion.insertAdjacentHTML( 'afterend', `<button type="button" class="wcpa_info_toggle">${icon}</button>` );
	companion.parentElement.insertAdjacentHTML( 'beforeend', `<div class="wcpa_info_toggle_content">${companionContent}</div>` );


	document.querySelectorAll( '.wcpa_info_toggle' ).forEach( ( toggle ) => {
		toggle.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			$( e.currentTarget ).closest( '.wcpa_row' ).find( '.wcpa_info_toggle_content' ).slideToggle();
		} );
	} );
}


function init() {
	wrapfurkidLegals();
	wrapGrabAndGoText();
	// hideGrabAndQtyLabel();
	wrapLegals();
	moreInfo();
	concessionInfoButton();
}

export default {
	init,
};
